// Eventcalendar configuration object
// This contains all the props and event handlers for the Eventcalendar component
import { getViewSettings } from './calendarConfig';

export const createEventCalendarConfig = ({
    // Core props
    timelineRef,
    zoomLevel,
    mySelectedDate,
    myEvents,
    resources,
    calendarColors,
    invalidResources,
    
    // Event handlers
    onSelectedDateChange,
    onPageLoaded,
    onEventClick,
    onEventCreated,
    onEventDelete,
    onEventDeleted,
    onEventUpdated,
    onEventHoverIn,
    onEventHoverOut,
    
    // Render functions
    myScheduleEvent,
    myScheduleEventContent,
    myHeader,
    myDayContent
}) => ({
    // Core configuration
    ref: timelineRef,
    className: 'motion-air-calendar',
    view: {
        timeline: {
            type: 'year',
            weekNumbers: true,
            rowHeight: 'variable',
            timeCellStep: zoomLevel
        }
    },
    data: myEvents,
    resources: resources,
    
    // Interaction settings
    clickToCreate: "double",
    dragToCreate: true,
    dragToMove: true,
    dragToResize: true,
    showEventTooltip: true,
    
    // Date and selection
    // selectedDate: mySelectedDate, // Removed to prevent rerenders - using alternative navigation
    onSelectedDateChange: onSelectedDateChange,
    onPageLoaded: onPageLoaded,
    
    // Event handlers
    onEventClick: onEventClick,
    onEventCreated: onEventCreated,
    onEventDelete: onEventDelete,
    onEventDeleted: onEventDeleted,
    onEventUpdated: onEventUpdated,
    onEventHoverIn: onEventHoverIn,
    onEventHoverOut: onEventHoverOut,
    
    // Styling and colors
    colors: calendarColors,
    invalid: invalidResources,
    
    // Render functions
    renderScheduleEvent: myScheduleEvent,
    renderScheduleEventContent: myScheduleEventContent,
    renderHeader: myHeader,
    renderDay: myDayContent
});

// Create a complete configuration object for the Eventcalendar component
export const createEventCalendarComponentConfig = ({
    // Core calendar props
    timelineRef,
    zoomLevel,
    mySelectedDate,
    myEvents,
    resources,
    calendarColors,
    invalidResources,
    
    // Event handlers
    onSelectedDateChange,
    onPageLoaded,
    onEventClick,
    onEventCreated,
    onEventDeleted,
    onEventUpdated,
    onEventHoverIn,
    onEventHoverOut,
    
    // Rendering functions
    myScheduleEvent,
    myScheduleEventContent,
    myHeader,
    myDayContent,
    
    // Additional options
    clickToCreate = "double",
    dragToCreate = true,
    dragToMove = true,
    dragToResize = true,
    className = 'motion-air-calendar'
}) => ({
    // Core props
    ref: timelineRef,
    className,
    view: getViewSettings(zoomLevel),
    data: myEvents,
    resources,
    selectedDate: mySelectedDate,
    
    // Interaction options
    clickToCreate,
    dragToCreate,
    dragToMove,
    dragToResize,
    showEventTooltip: true,
    
    // Event handlers
    onSelectedDateChange,
    onPageLoaded,
    onEventClick,
    onEventCreated,
    onEventDeleted,
    onEventUpdated,
    onEventHoverIn,
    onEventHoverOut,
    
    // Styling and colors
    colors: calendarColors,
    invalid: invalidResources,
    
    // Rendering functions
    renderScheduleEvent: myScheduleEvent,
    renderScheduleEventContent: myScheduleEventContent,
    renderHeader: myHeader,
    renderDay: myDayContent
});

// Alternative: Static configuration object (if you prefer not to use a function)
export const STATIC_EVENT_CALENDAR_CONFIG = {
    className: 'motion-air-calendar',
    clickToCreate: "double",
    dragToCreate: true,
    dragToMove: true,
    dragToResize: true,
    // Note: Dynamic values like ref, data, event handlers would need to be passed separately
};
